module.exports = __webpack_public_path__ + "media/music/bells_9-a2d81009.mp3";